import { GridColDef } from "@mui/x-data-grid";
import HospitalDetailButton from "./DetailButton";

export const hospitalColumns: GridColDef[] = [
    {
        field: '',
        renderCell: HospitalDetailButton,
        width: 150,
        headerName: '',
        sortable: false,
        filterable: false,
    },
    {
        field: 'id',
        minWidth: 150,
        headerName: 'ID',
        sortable: false,
        filterable: false
    },
    {
        field: 'hospitalName',
        headerName: 'Ad',
        flex: 1,
        minWidth: 80,
    },
    {
        field: 'cityCode',
        headerName: 'Şehir',
        flex: 1,
        minWidth: 80,
    },
];